import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-youtube',
  templateUrl: './home-youtube.component.html',
  styleUrls: ['./home-youtube.component.css']
})
export class HomeYoutubeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
